export default
{
  noPhoto: require('../asset/no-photo.png'),

  appIcon: require('../asset/appicon.png'),
};
